import { SITE_SECONDARY_COLOR } from "@api/constants";
import { OrdersPage, OrderStatus } from "@api/types/order";
import React, { FC, useState } from "react";

import FaIcon from "@components/FaIcon";
import { IconType } from "@components/FaIcon/FaIcon";
import Title from "@components/Title";

import OrderHistoryTable from "../OrderHistoryTable";
import Pagination from "../Pagination";
import { SearchInput } from "./styles";

const OrderHistoryContainer: FC<{
  page: OrdersPage;
  statuses: OrderStatus[];
}> = ({ page, statuses }) => {
  const [searchInput, setSearchInput] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const criteria = [];
  if (searchTerm && searchTerm.length > 0) {
    criteria.push({
      code: "searchTerm",
      namespace: "order",
      value: searchTerm,
    });
  }

  return (
    <>
      <div className="order-history-grid">
        <div>
          <Title>Search History</Title>
          <SearchInput
            placeholder={"Search History"}
            onChange={(e) => setSearchInput(e.currentTarget.value)}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                setSearchTerm(searchInput);
              }
            }}
            value={searchInput}
          />
          <span className="searchButton" onClick={() => setSearchTerm(searchInput)}>
            <FaIcon type={IconType.Search} color={SITE_SECONDARY_COLOR} />
          </span>
        </div>
        <div className="divider" />
        <div>
          <Title>Order History</Title>
          <OrderHistoryTable data={page.content} />
          <Pagination
            perPage={page.size}
            itemCount={page.totalElements}
            page={page.page}
            onPageChange={(value) => {}}
          />
        </div>
      </div>
      {/* language=CSS */}
      <style jsx>
        {`
          .order-history-grid {
            display: grid;
            grid-template-columns: 3fr 1px 9fr;
            grid-column-gap: 20px;
          }

          .divider {
            background-color: rgb(194, 194, 194);
          }

          .searchButton {
            display: inline-block;
            height: 42px;
            border-top: 1px solid rgb(194, 194, 194);
            border-right: 1px solid rgb(194, 194, 194);
            border-bottom: 1px solid rgb(194, 194, 194);
            padding-right: 10px;
            padding-top: 5px;
          }
        `}
      </style>
    </>
  );
};

export default OrderHistoryContainer;
